import { defaultTheme, ITheme, ThemeBuilder } from '@web/theme';


export const theme: ITheme = {
	...ThemeBuilder({
		vars: {
			...defaultTheme.vars,
			baseFontSize: '16px',
			baseBorderRadius: '.3em',
			baseVPadding: 2,
			baseHPadding: 2,
			basePaddingUnits: 'em',
			baseInputVPadding: 1.5,
			baseInputHPadding: 1,
			baseInputPaddingUnits: 'em',
			uiElementMinHeight: '1em',
			fabSize: 52,
		}
	}),
	brand: { bg: '#b4000d', txt: '#E9EDF0' },
	page: { bg: '#e9edf0', txt: '#01121d' },
	block: { bg: '#94ACBA', txt: '#01121d' },
	accent: { bg: '#C4D2DB', txt: '#10344C' },
	accent2nd: { bg: '#C4D2DB', txt: '#10344C' },
	accent3rd: { bg: '#C4D2DB', txt: '#10344C' },
	button: { bg: '#94ACBA', txt: '#01121d' },
	cta: { bg: '#b4000d', txt: '#E9EDF0' },
	boxShadow: {
		default: `0 1px 2px 0 rgba(148, 172, 186, .3), 0 1px 3px 1px rgba(148, 172, 186, .15)`,
		dark: `0 1px 2px 0 rgba(148, 172, 186, .3), 0 1px 3px 1px rgba(148, 172, 186, .15)`,
		hover: `0 1px 2px 0 rgba(148, 172, 186, .4), 0 1px 3px 1px rgba(148, 172, 186, .25)`,
		bottom: `0px 15px 10px -15px #10344C`,
	},
	fontFamily: `"Open Sans", sans-serif`
};

// $main-900: #01121d;
// $main-800: #10344C;
// $main-700: #3E677E;
// $main-600: #668699;
// $main-500: #94ACBA;
// $main-400: #C4D2DB;
// $main-300: #E9EDF0;
// $main-200: #FAFBFC;
